var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":_vm.routerTransition,"mode":"out-in"}},[_vm._t("default",function(){return [_c('router-view')]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }